import { Component, OnInit } from '@angular/core';
import {GoBaseComponent} from "../go-base.component";
import {GO_COMPONENTS} from "../../../enums/e-game-objects";

@Component({
  selector: 'go-game-events',
  templateUrl: './go-game-events.component.html',
  styles: []
})
export class GoGameEventsComponent extends GoBaseComponent {

  GO_COMPONENTS = GO_COMPONENTS;
  constructor() {
    super(GO_COMPONENTS.GAME_EVENTS);
  }


}



// WEBPACK FOOTER //
// /opt/app/develop/src/app/components/go/go-game-events/go-game-events.component.ts